<script>
  import InfoModal from "./InfoModal.svelte";

  let isOpen = false;
  const toggle = () => {
    isOpen = !isOpen;
  };

  export let btnClasses = "btn btn-primary btn-rounded";
</script>

<span class={btnClasses} on:click={toggle}>Why Book Direct?</span>
<InfoModal {toggle} {isOpen} />
